import { useConsentActions, useConsentStatus } from '@/ampli';

const ConsentBanner = () => {
  const status = useConsentStatus();
  const { handleAccept, handleDecline } = useConsentActions();

  if (status !== 'undecided') {
    return null;
  }

  return (
    <section
      aria-labelledby="consent-heading"
      className="surface-card fixed inset-x-4 bottom-4 z-[70] flex flex-col gap-4 p-5 sm:right-auto sm:max-w-md"
      id="consent-banner"
    >
      <h2 className="m-0 text-lg font-medium" id="consent-heading">
        We use cookies
      </h2>
      <p className="m-0 text-[15px] leading-[1.55] text-ink-soft">
        We use analytics cookies to understand how the site is used and improve
        it. They only load if you accept.
      </p>
      <div className="flex justify-end gap-2">
        <button
          className="h-10 cursor-pointer rounded-xl border border-line-strong bg-white px-4 text-[15px] font-medium text-ink"
          onClick={handleDecline}
          type="button"
        >
          Decline
        </button>
        <button
          className="button-primary h-10 px-4 text-[15px]"
          onClick={handleAccept}
          type="button"
        >
          Accept
        </button>
      </div>
    </section>
  );
};

export default ConsentBanner;
